// extracted by mini-css-extract-plugin
module.exports = {"parDiv":"skills-module--parDiv--v0fHm","flip":"skills-module--flip--17cNb","front":"skills-module--front--34v4M","back":"skills-module--back--2cImZ"};